import { ChevronDown, Plus } from 'lucide-react';
import AddCommitteeDrawer from './AddCommitteeDrawer';
import './styles/CommitteeButton.css';

interface Props {
  onClick: () => void;
}

const AddCommitteeButton = ({ onClick }: Props) => {
  return (
    <button onClick={onClick} className="committee-btn">
      <div className="committee-btn-left">
        <Plus size={16} />
        <span className="committee-btn-text">Add Committees</span>
      </div>

      <div className="committee-btn-divider" />

      <ChevronDown size={16} />
    </button>
  );
};

export default AddCommitteeButton;
